import { render, staticRenderFns } from "./orderRelationListSelect.vue?vue&type=template&id=5d8420b2&scoped=true"
import script from "./orderRelationListSelect.vue?vue&type=script&lang=js"
export * from "./orderRelationListSelect.vue?vue&type=script&lang=js"
import style0 from "./orderRelationListSelect.vue?vue&type=style&index=0&id=5d8420b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8420b2",
  null
  
)

export default component.exports